export default {
  title: 'Il tuo dominio',
  description:
    "Esegui le app del tuo team su un dominio di tua proprietà invece che sull'indirizzo condiviso. Collega il dominio una volta sola: dashboard, portale ordini, editor del sito e studio del sito ricevono ciascuno un indirizzo al suo interno.",
  read_only_description:
    'Il dominio su cui questo partner esegue le sue app. Solo il partner può collegarlo o scollegarlo.',
  read_only_empty: 'Questo partner non ha collegato alcun dominio.',
  not_connected: {
    label: 'Dominio',
    hint: 'Il dominio di tua proprietà, senza www — ad esempio tuomarchio.it. Poi aggiungi presso il tuo provider di dominio i record DNS che ti mostriamo.',
    placeholder: 'tuomarchio.it',
    connect: 'Collega',
  },
  apps: {
    dashboard: 'Dashboard',
    oms: 'Portale ordini',
    storefront: 'Editor del sito',
    website_studio: 'Studio del sito',
  },
  status: {
    active: 'Attivo',
    pending: 'In attesa del DNS',
    failed: 'Richiede attenzione',
    disabled: 'Scollegato',
  },
  records: {
    title: 'Aggiungi questi record DNS per {{root}} presso il tuo provider di dominio',
  },
  instructions: {
    title: 'Come aggiungere i record',
    step_provider:
      'Accedi dove viene gestito il DNS di {{root}}: di solito il provider da cui hai acquistato il dominio, oppure un servizio DNS come Cloudflare.',
    step_add:
      'Apri le impostazioni DNS di {{root}} e aggiungi ogni record qui sotto: scegli il tipo, poi copia il nome e il valore esattamente come sono. Lascia il TTL al valore predefinito.',
    step_check:
      'Salva i record, poi fai clic su «{{button}}». La maggior parte dei provider pubblica le modifiche in pochi minuti; alcuni impiegano fino a 48 ore.',
    tip_name:
      'Nel campo del nome la maggior parte dei provider vuole solo la parte prima di {{root}}, mostrata in grassetto. Se il tuo chiede il nome completo, copia quello qui sotto.',
    tip_cloudflare:
      'Su Cloudflare, imposta i record CNAME su «Solo DNS» (nuvola grigia). Un record con proxy nasconde il CNAME, quindi il dominio non può essere verificato.',
    tip_existing: 'Non modificare i record esistenti per {{root}} e www: il tuo sito continua a funzionare come prima.',
  },
  summary: {
    live: 'La tua dashboard è attiva su {{host}}.',
    pending:
      'Controlliamo regolarmente i tuoi record DNS. I nuovi record possono richiedere fino a 48 ore per essere trovati.',
    failed: 'Alcuni record non sono stati verificati. Correggi i record segnalati sotto e controlla di nuovo.',
    relogin:
      "Quando {{host}} sarà attivo, il tuo team accederà da lì. Alla prima visita dovrà effettuare di nuovo l'accesso.",
  },
  buttons: {
    check_again: 'Controlla di nuovo',
    disconnect: 'Scollega',
    retry: 'Riprova',
  },
  disconnect_confirm: {
    title: 'Scollegare {{root}}?',
    description: "Le tue app tornano all'indirizzo condiviso e i link su {{root}} smettono di funzionare.",
    ok: 'Scollega',
  },
  toasts: {
    load_error: 'Impossibile caricare il tuo dominio.',
    load_error_read_only: 'Impossibile caricare il dominio di questo partner.',
    connected: 'Dominio collegato. Aggiungi i record DNS qui sotto.',
    connect_failed: 'Impossibile collegare il dominio.',
    check_started: 'Controllo dei tuoi record DNS in corso.',
    check_failed: 'Impossibile avviare il controllo. Riprova tra un minuto.',
    disconnected: 'Dominio scollegato.',
    disconnect_failed: 'Impossibile scollegare il dominio.',
  },
};
